import { extend, localize, setInteractionMode } from 'vee-validate';
import { confirmed, email, integer, max_value as maxValue, min_value as minValue, numeric, required } from 'vee-validate/dist/rules';
import it from 'vee-validate/dist/locale/it.json';

setInteractionMode('passive');

extend('required', required);
extend('email', email);
extend('confirmed', confirmed);
extend('integer', integer);
extend('min_value', minValue);
extend('max_value', maxValue);
extend('numeric', numeric);

// improve when multi languages
export function setLocale(locale: string) {
    localize(locale, it)
}
